import { LabelPageId } from "@akc/biz-api";
import { getUrlParam } from "../../../utils/url-parse";

const { merchantShopCode } = getUrlParam();

export const initParams = (): any => {
  let {
    activitySpuId = "",
    baseProductId = "",
    queryType = "",
    activityNo,
    merchantShopCode,
    resourceCode,
    selectionProductType = "",
    bodyIdList = [],
    brandIds = [],
  } = getUrlParam();
  try {
    bodyIdList = decodeURIComponent(bodyIdList).split(",");
    brandIds = decodeURIComponent(brandIds).split(",");
  } catch (e) {
    console.error(e);
  }
  let queryParams: any = {
    pageId: LabelPageId.h5ActivityDetail,
  };
  if (activitySpuId && queryType) {
    queryParams = {
      // 商品详情页跳过来的
      useType: 1,
      queryType: 14,
      objectIds: [activitySpuId],
      baseProductIds: [baseProductId],
    };
  } else if (merchantShopCode && resourceCode) {
    queryParams = {
      // 查询店铺维度下素材列表
      queryType: 17,
      objectIds: [merchantShopCode],
      resourceCode,
    };
  } else {
    queryParams = {
      // 档期详情页跳过来的
      useType: 2,
      queryType: 5,
      objectIds: activityNo ? activityNo.split(",") : [],
    };
  }
  if (!selectionProductType) {
    return queryParams;
  }
  const opts: any = {
    pageId: LabelPageId.h5ActivityDetail,
    objectIds: bodyIdList,
    ...queryParams,
  };

  switch (selectionProductType) {
    case "BASE_PRODUCT":
      opts.queryType = 14;
      break;
    case "ACTIVITY":
      opts.queryType = 5;
      break;
    case "SCHEDULE":
      opts.queryType = 10;
      break;
    case "MERCHANT_SHOP":
    case "ALL":
      opts.queryType = 17;
      break;
    case "BRAND":
      opts.frontCodes = bodyIdList.map(e => ({
        type: 2,
        code: e,
      }));
      delete opts.queryType;
      delete opts.objectIds;
      break;
  }
  if (queryParams?.frontCodes || opts?.frontCodes) {
    opts.frontCodes = [...(queryParams?.frontCodes || []), ...(opts?.frontCodes || [])];
    opts.frontCodes = opts.frontCodes.filter(
      (item, index, self) =>
        index === self.findIndex(t => t.type === item.type && t.code === item.code),
    );
  }
  return opts;
};

export const sortListFunc = merchantShopCode => {
  return merchantShopCode
    ? [
        {
          name: "综合",
          code: 11,
        },
        {
          name: "销量",
          code: 31,
        },
        {
          name: "转发量",
          code: 34,
        },
        {
          name: "发布时间",
          code: 1,
        },
        {
          name: "转化率",
          code: 38,
        },
      ]
    : [
        {
          name: "综合",
          code: 11,
        },
        {
          name: "销量",
          code: 31,
        },
        {
          name: "价格",
          code: 29,
        },
        {
          name: "转发量",
          code: 34,
        },
        {
          name: "发布时间",
          code: 1,
        },
        {
          name: "转化率",
          code: 38,
        },
      ];
};
